// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-wrapper {\n  position: static;\n  margin: 0;\n  padding: 0;\n  width: 99.9%;\n  overflow-y: hidden;\n}\n\n.dashboard-container {\n  display: flex;\n  width: 100%;\n  align-items: stretch;\n  background: #efefef;\n  max-height: calc(100vh - 92px);\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n\n.content {\n  width: 100%;\n  padding: 10px;\n  margin-left: 0;\n  overflow-y: auto;\n}", ""]);
// Exports
module.exports = exports;
